/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import {
  OTELMetric,
  OTELMetric$Outbound,
  OTELMetric$outboundSchema,
} from "./otelmetric.js";
import {
  OTELScope,
  OTELScope$Outbound,
  OTELScope$outboundSchema,
} from "./otelscope.js";

/**
 * OTEL scope metrics container
 */
export type OTELScopeMetrics = {
  /**
   * Array of metrics
   */
  metrics?: Array<OTELMetric> | undefined;
  /**
   * OTEL instrumentation scope
   */
  scope?: OTELScope | undefined;
};

/** @internal */
export type OTELScopeMetrics$Outbound = {
  metrics?: Array<OTELMetric$Outbound> | undefined;
  scope?: OTELScope$Outbound | undefined;
};

/** @internal */
export const OTELScopeMetrics$outboundSchema: z.ZodMiniType<
  OTELScopeMetrics$Outbound,
  OTELScopeMetrics
> = z.object({
  metrics: z.optional(z.array(OTELMetric$outboundSchema)),
  scope: z.optional(OTELScope$outboundSchema),
});

export function otelScopeMetricsToJSON(
  otelScopeMetrics: OTELScopeMetrics,
): string {
  return JSON.stringify(
    OTELScopeMetrics$outboundSchema.parse(otelScopeMetrics),
  );
}
